export default function PHP_explode() {
  return (
    <div>
      <h1>PHP_explode</h1>
    </div>
  );
}
